/**
 * @Description 组件 室外实时定位
 * @Author 
 * @Date 
 */
/* HTML */
<template>
	<div style="height: 100%;width: 100%;position: relative;background-color: rgba(3,11,24,0.87);border: 2px solid #234582;">

		<!-- 加载中 -->
		<div :class="{'none-map-item': true, 'off': flags.falg_AMap_inited}">
			<img alt="加载中" v-show="!flags.falg_AMap_inited" title="加载中" src="@/static_dazzle/images/loading_1.gif">
		</div>

		<!-- 地图 容器 -->
		<div id="mapItem" class="view-amap-box" @contextmenu.prevent="onContextmenu" style="height: 100%;width: 100%;text-align: left;"></div>

		<!-- 条件查询 start -->
		<el-form v-if="false" :inline="true" :model="filters" ref="filters" class="form-out-map" v-show="flags.falg_AMap_inited">
			<el-form-item prop="address">
				<el-input id="addressInp" style="width: 240px;" v-model="filters.address" placeholder="请输入目的地名称" clearable @keyup.enter.native="handleSearch" @clear="handleSearch">
					<el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
				</el-input>
			</el-form-item>
			<el-form-item v-show="false" prop="">
				<el-input style="width: 240px;" v-model="filters.address" placeholder="请输入目的地名称" clearable>
					<el-button slot="append" icon="el-icon-search"></el-button>
				</el-input>
			</el-form-item>
		</el-form>
		<!-- 条件查询 end -->

		<div v-if="false && tbRows.length > 0" :class="{'aside-button-box': true, 'r-0': !showAsideFlag, 'r-30': showAsideFlag}" style="text-align: end">
			<el-tooltip v-if="true" :content="showAsideFlag ? '关闭设备表' : '开启设备表'" placement="top">
				<el-button class="aside-button" style="z-index: 9999;position: relative" :type="showAsideFlag ? 'success' : 'info'" :icon="showAsideFlag ? 'el-icon-back' : 'el-icon-right'" @click="changeAsideFlag" round />
				<!--</el-badge>-->
			</el-tooltip>
		</div>

		<!-- 设备表展示myAside -->
		<el-aside v-if="false && showAsideFlag" id="realtimeLocationMyAsideTable" style="position: absolute;top: 0; bottom: 0; left: 0;height: 100%;font-size: 5px;padding: 1vh 1vh 1vh 1vh;background: #ffffffd6;z-index: 10;width: 430px;overflow-x: auto;">
			<u-table ref="realtimeLocationFilterTable" fixed-columns-roll beautify-table header-drag-style show-body-overflow="tooltip" highlight-current-row :data="tbRows.filter(data => !keywords ||
					( data.did && data.did.toLowerCase().includes(keywords.toLowerCase().replaceAll(' ','')) ) ||
					( data.address && data.address.toLowerCase().includes(keywords.toLowerCase().replaceAll(' ','')) ) ||
					( data.didName && data.didName.toLowerCase().includes(keywords.toLowerCase().replaceAll(' ','')) ))" size="mini" use-virtual row-id="id" @filter-change="filterChange" border>
				<u-table-column :resizable=false align="center" header-align="center" prop="did" label="设备号" width="140" sortable :border-line=false />

				<u-table-column :resizable=false align="center" header-align="center" :tree-node="true" prop="didName" width="120" label="设备名称" :border-line=false />

				<u-table-column :resizable=false :border-line=false align="center" header-align="center" width="150">
					<template slot="header" slot-scope="scope">
						<el-input v-model="keywords" size="mini" placeholder="输入关键字" clearable />
					</template>
					<template slot-scope="scope">
						<!-- 到这 -->
						<el-button icon="el-icon-position" v-if="!$checkEmpty(scope.row.lngGc) || !$checkEmpty(scopr.row.latGc)" size="mini" :type="!$checkEmpty(scope.row.alarms) ? 'danger' : 'primary'" @click="handleToHere(scope.$index, scope.row)" style="padding: 7px 5px;">到这</el-button>
						<!-- 轨迹 -->
						<el-button icon="el-icon-view" size="mini" :type="!$checkEmpty(scope.row.alarms) ? 'danger' : 'primary'" @click="handleTrack(scope.$index, scope.row)" style="padding: 7px 5px;margin: 0px;">轨迹</el-button>
					</template>
				</u-table-column>
			</u-table>
		</el-aside>
		<!-- 设备表展示myAside end -->

		<!-- 区域 快捷列表 start -->
		<div :class="{'area-items-box': true, 'roll-call-on': false}" v-show="areas.length > 0">
			<ul>
				<li v-for="(item, index) in areas" :key="index" :class="{'on': false}" :title="item.label" @click="clickAreaRow(item)">{{item.label}}</li>
				<li v-if="this.$checkEmpty(areas)" title="暂无区域">暂无区域</li>
			</ul>
		</div>
		<!-- 区域 快捷列表 end -->

		<!-- websocket 组件 -->
		<SubWebsoket v-if="wsFilter.creatWsFlag" ref="positionWs_out" :wsUrl="wsFilter.wsUrl" :wsKey="wsFilter.wsKey" :autoRecreatFlag="wsFilter.autoRecreatFlag" :wsOnopen="wsFilter.wsOnopen" :wsOnmessage="wsFilter.wsOnmessage" :wsOnerror="wsFilter.wsOnerror" :wsOnclose="wsFilter.wsOnclose" :winMessageFn="wsFilter.winMessageFn" />

	</div>
</template>

/* JS */
<script>
	// 公共方法
	import GlobalFun from '@/global/global-function';
	// 公共变量
	import GlobalVar from '@/global/global-variable';
	// API ws
	import ApiNfcWs from '@/request/api-nfc_ws';
	// API gps tag
	import ApiGpsTag from '@/request/api-gps-tag';
	// API 报警 GNSS
	import ApiAlarmGNSS from '@/request/api-alarm-gnss';
	// websocket
	import SubWebsoket from '@/components/SubWebsoket';
	import { mapGPSGaode } from '@/static_dazzle/plugins/amap/map_gps_gaode';
	// import {list} from './list';

	export default {
		/**
		 * @Des 组件名
		 * @Auth
		 * @Date 
		 */
		name: "DeviceDistribution",

		/**
		 * @Des 组件注册
		 * @Auth
		 * @Date 
		 */
		components: {
			// websocket
			SubWebsoket
		}, // components

		/**
		 * @Des 属性值
		 * @Auth
		 * @Date 
		 */
		props: {

		}, // props

		/**
		 * @Des 数据定义
		 * @Auth
		 * @Date 
		 */
		data() {
			return {
				// 地图 组件
				mapFn: new mapGPSGaode(),
				// 地理位置 自动搜索
				autocomplete: null,

				// key list
				keys: [],
				// 数据 list
				rows: [],
				// 列表 list
				tbRows: [],

				// 显示/隐藏 右侧列表
				showAsideFlag: false,
				// 关键字
				keywords: '',

				// 参数
				filters: {
					// 地址
					address: '',
				},

				// flags
				flags: {
					falg_subscribes: false, // flag 监听广播
					falg_AMap_inited: false, // flag AMap 已加载
				},

				// 报警 类型
				alarmStates: {},
				// 报警 开关
				alarmStateSwitchs: {},
				// 标签报警
				map_tag_alarm: new this.HashMap(),

				// 室内地图 组织结构
				organizations: [],
				// 室内地图 区域
				areas: [],
				// 系统时间
				systemTime: null,
				// 计时器
				timer_101: null, // 计时器 查询标签

				// 报警类型
				alarmStatus: {},

				// websoket
				wsFilter: {
					// 创建 ws flag
					creatWsFlag: false,
					// websocket路径
					wsUrl: ApiNfcWs.positionWs,
					// websocket key
					wsKey: '_GPS_Position',
					// 自动重新连接
					autoRecreatFlag: true,
					// 连接已打开
					wsOnopen: this.wsOnopen,
					// 数据推送
					wsOnmessage: this.wsOnmessage,
					// 发生错误
					wsOnerror: this.wsOnerror,
					// 断开连接
					wsOnclose: this.wsOnclose,
					// 无 this.wsOnmessage 时，onmessage 监听回调 {方法名称}
					winMessageFn: null,
					// this.onMessage 与 this.wsOnmessage 存一即可
				}, // wsFilter
				timer_ws_ping: null, // 计时器 ws ping

				// 模拟坐标
				infos: [{
						did: '8801100100010001',
						lngGc: 116.312043,
						latGc: 39.983309
					},
					{
						did: '8801100100010002',
						lngGc: 116.312243,
						latGc: 39.983309
					},
					{
						did: '8801100100010003',
						lngGc: 116.312643,
						latGc: 39.983309
					},
					{
						did: '8801100100010004',
						lngGc: 116.312843,
						latGc: 39.983309
					},
					{
						did: '8801100100010005',
						lngGc: 116.313043,
						latGc: 39.983309
					},

					{
						did: '8801100100010006',
						lngGc: 116.314043,
						latGc: 39.983309
					},
					{
						did: '8801100100010007',
						lngGc: 116.316243,
						latGc: 39.984309
					},
					{
						did: '8801100100010008',
						lngGc: 116.318643,
						latGc: 39.985309
					},
					{
						did: '8801100100010009',
						lngGc: 116.310843,
						latGc: 39.986309
					},
					{
						did: '8801100100010010',
						lngGc: 116.323043,
						latGc: 39.987309
					},
					{
						did: '8801100100010011',
						lngGc: 116.423043,
						latGc: 39.987309
					},
				],
				// 溢出项 个数
				overIndex: 0,

			} // return
		}, // data

		/**
		 * @Des 初始化
		 * @Auth
		 * @Date 
		 */
		created() {
			// 查询 报警类型
			this.searchAlarmStatus();
		}, // created

		/**
		 * @Des 加载完成
		 * @Auth
		 * @Date 
		 */
		mounted() {
			window.goToHere = this.goToHere;

			// 初始化 地图
			this.initMap();

			// 查询 设备GNSS
			// this.searchTags_GNSS();

			// 初始化 websocket
			this.initPositionWs();

		}, // mounted

		/**
		 * @Des 销毁之前
		 * @Auth
		 * @Date 
		 */
		beforeDestroy() {
			// 关闭 消息订阅
			this.endSubscribes();
			// ws 关闭
			this.wsFilter.creatWsFlag = false;
			window.goToHere = null;

			// 销毁地图
			this.mapFn.destroyMap();

			// 关闭 timer
			this.endTimers();
		}, // beforeDestroy

		/**
		 * @Des 销毁
		 * @Auth
		 * @Date 
		 */
		destroyed() {

		}, // destroyed

		/** 缓存组件生命周期 */
		activated() {

		},
		deactivated() {

		},

		/**
		 * @Des 方法定义
		 * @Auth
		 * @Date 
		 */
		methods: {
			/**
			 * @Des 关闭 timer
			 * @Auth
			 * @Date
			 */
			endTimers() {
				// 清除计时器
				if(!this.$checkEmpty(this.timer_101)) {
					clearTimeout(this.timer_101);
					this.timer_101 = null;
				}
				// 清除计时器
				if(!this.$checkEmpty(this.timer_ws_ping)) {
					clearTimeout(this.timer_ws_ping);
					this.timer_ws_ping = null;
				}
			}, // endTimers
			/**
			 * @Des 右击
			 * @Auth
			 * @Date
			 */
			onContextmenu(e) {
				/** 右键菜单 */
				// this.mapFn.onContextmenu(this, e);
			},

			/**
			 * @Des 初始化 地图
			 * @Auth
			 * @Date
			 */
			async initMap() {
				// 地图 组件
				await this.mapFn.initMap('mapItem', {
					// 控制组件 初始化
					controlBarFlag: false,
					// 模块 地理编码
					geocoderFlag: false,
					// 添加 地图控制插件
					mapPluginsFlag: false,
					// 地图类型
					mapStyle: 'amap://styles/blue',
				}, (AMap) => {
					// flag AMap 已加载
					this.flags.falg_AMap_inited = true;

					// 初始化 地图附属
					this.initMapLayers();
					// 初始化 点聚合
					this.initMarkerCluster();
				});
			}, // initMap

			/**
			 * @Des 初始化 地图附属
			 * @Auth
			 * @Date
			 */
			initMapLayers() {

				// 设置 中心 级别
				// this.mapFn.setZoomAndCenter(13, [124.31671, 40.01149]);

				// 添加 自定义地图
				// this.addImageLayer();

				// 初始化 自动搜索
				// 地理位置 自动搜索
				this.autocomplete = new this.mapFn.initAutocomplete({
					input: 'addressInp'
				});
			}, // initMapLayers

			/**
			 * @Des 添加 自定义地图
			 * @Auth
			 * @Date
			 */
			addImageLayer() {
				// 创建 覆盖物 image
				this.mapFn.creatImageLayer({
					name: '智慧工厂',
					url: '/static/images/map/mapLayers/jg-gongdi-001.png', // 修改为你自己的图片链接
					bounds: [
						[117.261354, 36.751667], // 图片左下角经纬度坐标
						[117.263744, 36.750307] // 图片右上角经纬度坐标，可以根据图片大小调整坐标值
					],
					zIndex: 20, // 设置覆盖物的层级
					opacity: 1, // 设置覆盖物的透明度
				}); // creatImageLayer
			}, // addImageLayer

			/**
			 * @Des 添加 旗帜
			 * @Auth
			 * @Date
			 */
			// 添加 旗帜
			addFlagMarkers() {
				// 项目
				let projectRow = Object.assign({}, this.organizations[0]);
				// 空值 中止
				if(this.$checkEmpty(projectRow)) return false;

				// 区域
				let areaRows = Object.assign([], projectRow.children);
				Object.assign([], areaRows).forEach((row, index) => {
					// 非区域 跳过
					if(row.level != 2) return true;
					let areaNode = Object.assign({}, row.node);
					// 空值 跳过
					if(this.$checkEmpty(areaNode)) return true;

					// Icon 旗帜
					let flagIcon = this.mapFn.creatIcon({
						size: [60, 60],
						imageSize: [60, 60],
						icon: '/static/images/map/outdoorIocns/iocn-flag.webp'
					});

					let flagDid = ['flagMarker', areaNode.areaId].join('_');
					// Marker 旗帜
					let flagMarker = this.mapFn.creatMarker({
						position: [areaNode.startPointX, areaNode.startPointY], // [117.263698, 36.750353] // 红旗所在的经纬度坐标
						offset: [28, -32], // 将红旗位置上移一些，使其正好位于覆盖物左上角
						icon: flagIcon,
						extData: {
							"markerID": flagDid,
							"markerItem": Object.assign({}, row, {
								did: flagDid
							})
						},
						zIndex: 30, // 设置比覆盖物更高的层级
						clickMarker: this.clickFlagMarker,
						// rightClickMarker: this.rightClickFlag
					});
					// 将标记对象添加到地图上
					this.mapFn.addMarker(flagDid, flagMarker);

				});
			}, // addFlagMarkers
			/**
			 * @Des 点击 旗帜
			 * @Auth
			 * @Date
			 */
			clickFlagMarker(e) {
				return false;
				e = e || event;
				let extData = e.target.getExtData();

				let markerItem = Object.assign({}, extData.markerItem);
				let areaRow = Object.assign({}, markerItem.node);
				// 空值 中止
				if(this.$checkEmpty(areaRow) || this.$checkEmpty(markerItem.children)) return false;

				// 地图
				let mapRows = Object.assign([], markerItem.children);
				let mapRow = {};
				mapRows.forEach((row, index) => {
					// 已有值 跳过
					if(!this.$checkEmpty(mapRow)) return true;
					// 空值 跳过
					if(this.$checkEmpty(row) || this.$checkEmpty(row.node)) return true;
					mapRows = Object.assign({}, row.node);
				});

				// 路由 跳转
				this.$router.replace({
					path: '/manager/location/monitor',
					query: {
						areaId: areaRow.areaId,
						mapId: mapRow.mapId
					}
				}, () => {}, () => {});
			}, // clickFlagMarker
			/**
			 * @Des 右击 旗帜
			 * @Auth
			 * @Date
			 */
			rightClickFlag(e) {
				return false;
				e = e || event;
				let extData = e.target.getExtData();

				// 空值 中止
				if(this.$checkEmpty(this.organizations[0]) || this.$checkEmpty(this.organizations[0].children)) return false;

				let items = [];
				let has_children_falg = false;
				this.organizations[0].children.forEach((row, index) => {
					let item = {
						label: row.label,
						icon: "el-icon-map-location",
						divided: true,
						minWidth: 0,
						onClick: () => {
							// 路由 跳转
							this.$router.replace({
								path: '/manager/location/monitor',
								query: {
									mapId: row.id
								}
							}, () => {}, () => {});
						},
					};

					// 子菜单
					let childItems = [];
					Object.assign([], row.children).forEach((r, i) => {
						if(!has_children_falg) {
							has_children_falg = true;
						}
						let childItem = {
							label: r.label,
							icon: "el-icon-location-outline",
							divided: true,
							minWidth: 0,
							onClick: () => {
								// 路由 跳转
								this.$router.replace({
									path: '/manager/location/monitor',
									query: {
										areaId: row.id,
										mapId: r.id
									}
								}, () => {}, () => {});
							},
						};
						childItems.push(childItem);
					});
					if(childItems.length > 0) {
						item.children = Object.assign([], childItems);
						delete item['onClick'];
					}
					items.push(item);
				});

				this.$contextmenu({
					items: items,
					// event, event.clientX event.clientY
					x: event.clientX,
					y: event.clientY,
					customClass: ("context-menu-flag" + (!has_children_falg ? ' none-children' : '')),
					zIndex: 3,
					minWidth: 50,
				});
			}, // rightClickFlag

			//执行搜索
			handleSearch() {
				// 地图未加载完成 跳过
				if(!this.flags.falg_AMap_inited) return false;

				// 空值 中止
				if(this.$checkEmpty(this.filters.address)) {
					// 地理位置 清除 marker
					this.autocomplete.clearPlace();
					return false;
				}

				// 地理编码
				this.mapFn.geoCode(this.filters.address, (status, result) => {
					if(status === 'complete' && result.geocodes.length) {
						let geocode = Object.assign({}, result.geocodes[0]);
						let adcode = geocode.adcode || '';

						// 地理位置 自动搜索
						this.autocomplete.setPlace(adcode, this.filters.address);
					} else {
						console.log('根据地址查询位置失败', status, result);
					}
				});
			}, // handleSearch

			/**
			 * @Des 绘制 图元
			 * @Auth
			 * @Date
			 */
			drawMarker(info) {
				// 创建 marker
				let marker = this.mapFn.creatMarker({
					label: {
						content: info.didName || info.did.substring(info.did.length - 4),
						// content:'手牵手',
						direction: "top",
						offset: [-10, 0],
					},
					offset: [0, 0],
					position: [parseFloat(info.lngGc), parseFloat(info.latGc)],
					icon: !this.$checkEmpty(info.alarms) ? "//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-red.png" : "//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png",
					extData: {
						"markerID": info.did,
						"markerItem": info
					},

				});
				marker.content = this.initMarkerContent(info);

				// 添加 marker
				this.mapFn.addMarker(info.did, marker);

			}, // drawMarker
			/**
			 * @Des 移除 图元
			 * @Auth
			 * @Date
			 */
			removeMarker(did) {
				// 添加 marker
				this.mapFn.removeMarker(did);
			},

			// ========================================= 点聚合 start ========================================= //
			/**
			 * @Des 初始化 点聚合
			 * @Auth
			 * @Date
			 */
			initMarkerCluster() {
				// 地图未加载完成 跳过
				if(!this.flags.falg_AMap_inited) return false;
				// 移除 点聚合marker
				this.removeAllClusterMarkers();

				let markers = [];
				Object.assign([], this.rows).forEach((row, index) => {
					// 空值 跳过
					if(this.$checkEmpty(row.lngGc) || this.$checkEmpty(row.latGc)) return true;

					// 创建 marker
					let marker = this.mapFn.creatMarker({
						label: {
							content: row.didName || row.did.substring(row.did.length - 4),
							direction: "top",
							offset: [-10, 0],
						},
						offset: [0, 0],
						position: [parseFloat(row.lngGc), parseFloat(row.latGc)],
						icon: !this.$checkEmpty(row.alarms) ? "//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-red.png" : "//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png",
						extData: {
							"markerID": row.did,
							"markerItem": row
						},
					});
					marker.content = this.initMarkerContent(row);

					markers.push(marker);
				});

				// 点聚合
				!this.$checkEmpty(markers) && this.mapFn.creatMarkerCluster(Object.assign([], markers));
			}, // initMarkerCluster
			/**
			 * @Des 添加 点聚合marker
			 * @Auth
			 * @Date
			 */
			addClusterMarker(info) {
				// 地图未加载完成 跳过
				if(!this.flags.falg_AMap_inited) return false;
				// 空值 中止
				if(this.$checkEmpty(info) || this.$checkEmpty(info.did)) return false;

				// 创建 marker
				let marker = this.mapFn.creatMarker({
					label: {
						content: info.didName || info.did.substring(info.did.length - 4),
						direction: "top",
						offset: [-10, 0],
					},
					offset: [0, 0],
					position: [info.lngGc, info.latGc],
					icon: !this.$checkEmpty(info.alarms) ? "//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-red.png" : "//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png",
					extData: {
						"markerID": info.did,
						"markerItem": Object.assign({}, info)
					},
				});
				marker.content = this.initMarkerContent(info);

				// 点集合 添加 marker
				this.mapFn.addClusterMarker(marker);
			}, // addClusterMarker
			/**
			 * @Des 移除 点聚合marker
			 * @Auth
			 * @Date
			 */
			removeClusterMarker(did) {
				// 地图未加载完成 跳过
				if(!this.flags.falg_AMap_inited) return false;
				// 空值 中止
				if(this.$checkEmpty(did)) return false;
				// 点集合 移除 marker
				this.mapFn.removeClusterMarker(did);
			}, // removeClusterMarker
			/**
			 * @Des 更新 点聚合marker
			 * @Auth
			 * @Date
			 */
			updateClusterMarker(info) {
				// 地图未加载完成 跳过
				if(!this.flags.falg_AMap_inited) return false;
				// 空值 中止
				if(this.$checkEmpty(info) || this.$checkEmpty(info.did)) return false;
				// 点集合 移除 marker
				this.removeClusterMarker(info.did);
				// 点集合 移除 marker
				this.addClusterMarker(info);
			}, // updateClusterMarker
			/**
			 * @Des 移除 点聚合marker
			 * @Auth
			 * @Date
			 */
			removeAllClusterMarkers() {
				// 地图未加载完成 跳过
				if(!this.flags.falg_AMap_inited) return false;

				// 点集合 移除 markers
				this.mapFn.removeClusterMarkers();
				return false;
				// 移除 原marker
				Object.assign([], this.keys).forEach((did) => {
					// 点集合 移除 marker
					this.mapFn.removeClusterMarker(did);
				});
			}, // removeAllClusterMarkers

			// ========================================= 点聚合 end ========================================= //

			/**
			 * @Des 图元 content
			 * @Auth
			 * @Date
			 */
			initMarkerContent(item) {
				let alarmHtmls = [];
				Object.assign([], item.alarms).forEach((row, index) => {
					// 空值 跳过
					if(this.$checkEmpty(row) || this.$checkEmpty(row.alarmName) || this.$checkEmpty(row.time)) return true;
					alarmHtmls.push('<span style="color: #2700ff">' + row.alarmName + '  ' + this.$moment(row.time).format('YYYY-MM-DD HH:mm:ss') + '</span>');
				});
				let alarmsHtml = alarmHtmls.length > 0 ? ['<label style="color:#000000"><span style="float: left;">报警信息:</span><p style="color: #2700ff;padding-left: 56px;">', alarmHtmls.join('<br>'), '</p></label></p>'].join('') : '';

				let hidAndDtidResult = [];
				// <label style="color:#000000">类型:<span style='color: #2700ff'>` + hidAndDtidResult[1] + `</span></label></p>
				let _content = '';
				if(item.type == 'GT808') {
					_content = `
		       <div class="map-info-content-box" style="background-color: #fff;font-size: small;border-radius: 10px;opacity: 0.9;padding: 10px;box-shadow: 0px 0px 20px 0px rgba(0,0,0,1);">
		       <div style="text-align: center;"><h3 style="font-weight: bold;color: #000;">` + (item.didName || '') + `</h3></div>
		       <div style="text-align: center;"><h4 style="font-weight: bold;color: #000;">` + item.did + `</h4></div>
		       <div className="custom-infowindow input-card" style="z-index:999999999999;text-align: left;">
		       <label style="color:#000000">剩余电量:<span style='color: #2700ff'>` + (item.battery || item.power) + "%" + ` </span></label></p>
		       <label style="color:#000000">地理位置:<span style='color: #2700ff'>` + item.address + ` </span></label></p>
		       <label style="color:#000000">更新时间:<span style='color: #2700ff'>` + (this.$moment(item.uploadTime)).format('YYYY-MM-DD HH:mm:ss') + `</span></label></p>
		       ` + alarmsHtml + `
		       <label style="color:#000000">设备状态:<span style='color: #2700ff'>` + (this.formatDeviceStatus(item.deviceStatus)) + ` </span></label></p>
		       </div>
		       <div style="text-align: center">
		       <button type="button" class="button-custom-1" onclick="goToHere('` + [parseFloat(item.lngGc), parseFloat(item.latGc)] + `','` + item.did + `')">
		       <i class="el-icon-position"></i>
		       <span>到这</span>
		       </button>
		       </div>
		       </div>
		        `;
				} else {
					_content = `
		       <div class="map-info-content-box" style="background-color: #fff;font-size: small;border-radius: 10px;opacity: 0.9;padding: 10px;box-shadow: 0px 0px 20px 0px rgba(0,0,0,1);">
		       <div style="text-align: center;"><h3 style="font-weight: bold;color: #000;">` + (item.didName || '') + `</h3></div>
		       <div style="text-align: center;"><h4 style="font-weight: bold;color: #000;">` + item.did + `</h4></div>
		       <div className="custom-infowindow input-card" style="z-index:999999999999;text-align: left;">
		       <label style="color:#000000">气压:<span style='color: #2700ff'>` + item.air + "帕" + ` </span></label></p>
		       <label style="color:#000000">高度:<span style='color: #2700ff'>` + item.relativeAltitude + "米" + `</span></label></p>
		       <label style="color:#000000">定位方式:<span style='color: #2700ff'>` + '极速定位' + `</span></label></p>
		       <label style="color:#000000">工作模式:<span style='color: #2700ff'>` + (item.statusWorking === 18 || item.statusWorking === "快速模式" ? "快速模式" : "普通模式") + ` </span></label></p>
		       <label style="color:#000000">剩余电量:<span style='color: #2700ff'>` + (item.battery || item.power) + "%" + ` </span></label></p>
		       <label style="color:#000000">地理位置:<span style='color: #2700ff'>` + item.address + ` </span></label></p>
		       <label style="color:#000000">更新时间:<span style='color: #2700ff'>` + (this.$moment(item.uploadTime)).format('YYYY-MM-DD HH:mm:ss') + `</span></label></p>
		       ` + alarmsHtml + `
		       <label style="color:#000000">硬件版本:<span style='color: #2700ff'>` + item.versionHard + `</span></label></p>
		       <label style="color:#000000">软件版本:<span style='color: #2700ff'>` + item.versionSoft + `</span></label></p>
		       </div>
		       <div style="text-align: center">
		       <button type="button" class="button-custom-1" onclick="goToHere('` + [parseFloat(item.lngGc), parseFloat(item.latGc)] + `','` + item.did + `')">
		       <i class="el-icon-position"></i>
		       <span>到这</span>
		       </button>
		       </div>
		       </div>
		        `;
				}

				return _content;
			},

			formatDeviceStatus(deviceStatus) {
				if(!deviceStatus) return '无状态数据';

				try {
					const statusObj = JSON.parse(deviceStatus);
					// 使用 JSON.stringify 的格式化参数，缩进2个空格
					const formattedJson = JSON.stringify(statusObj, null, 2);

					// 将格式化后的 JSON 转换为 HTML 多行显示
					return formattedJson
						.replace(/\n/g, '<br>')
						.replace(/ /g, '&nbsp;')
						.replace(/\t/g, '&nbsp;&nbsp;&nbsp;&nbsp;');
				} catch(e) {
					return deviceStatus;
				}
			},

			/**
			 * @Des 到这
			 * @Auth
			 * @Date
			 */
			goToHere(lnglat, did) {
				// 地图未加载完成 跳过
				if(!this.flags.falg_AMap_inited) return false;
				// 空值 跳过
				if(this.$checkEmpty(lnglat[0]) || this.$checkEmpty(lnglat[1])) return false;

				this.mapFn.setZoomAndCenter(18, lnglat.split(','));
				this.mapFn.setZoom(20);
			}, // goToHere
			// 列表 到这
			handleToHere(index, item) {
				// 地图未加载完成 跳过
				if(!this.flags.falg_AMap_inited) return false;
				// 空值 跳过
				if(this.$checkEmpty(item.lngGc) || this.$checkEmpty(item.latGc)) return false;

				let infoContent = this.initMarkerContent(item);
				// 打开 信息窗体
				this.mapFn.updateInfoWindow(item.did, infoContent);
				// 打开 信息窗体
				this.mapFn.openInfoWindow([item.lngGc, item.latGc]);

				this.mapFn.setZoomAndCenter(10, [item.lngGc, item.latGc]);
				this.mapFn.setZoom(12);

				// 更新 点聚合marker
				// this.updateClusterMarker(item);
			}, // handleToHere
			// 跳转 设备历史轨迹
			handleTrack(index, item) {
				let did = item.did;
				let uploadTime = item.uploadTime;
				// 路由 跳转
				// this.$router.replace({path: '/manager/history/device-record', params: {did: did, uploadTime: uploadTime, tab: 'track'}}, ()=>{}, ()=>{});
				this.$router.push({
					name: 'device-record',
					params: {
						did: did,
						uploadTime: uploadTime,
						tab: 'track'
					}
				});
			}, // handleTrack

			// 显示/隐藏 右侧列表
			changeAsideFlag() {
				this.showAsideFlag = !this.showAsideFlag;
			},
			// 关键字变化
			filterChange() {

			}, // filterChange

			// ======================================================= 订阅消息 start ======================================================= //
			/**
			 * @Des 开启 消息订阅
			 * @Auth
			 * @Date 
			 */
			startSubscribes() {
				// 订阅 ws
				this.sub_wsMessageData = this.$pubsub.subscribe('wsMessageData', (name, data) => {
					//接收数据
					this.receiveWsData(Object.assign({}, data));
				});

				// 订阅消息 通知广播
				this.pubsubTransData = this.$pubsub.subscribe('pubsubTransData', (name, data) => {
					// 空值 中止
					if(this.$checkEmpty(data)) return false;
					// 数据 报警相关
					if(data.key == 'alarmData') {
						// 刷新 报警数据
						this.flushAlarmsData(Object.assign({}, data.data));
						// 刷新 位置数据
						this.flushPositionData();
						// 初始化 点聚合
						this.initMarkerCluster();
					} // 数据 报警相关

				}); // this.pubsubTransData

				// flag 监听广播
				this.flags.falg_subscribes = true;
			},
			/**
			 * @Des 关闭 消息订阅
			 * @Auth
			 * @Date 
			 */
			endSubscribes() {
				// 取消订阅 ws
				this.$pubsub.unsubscribe(this.sub_wsMessageData);
				// 取消订阅 通知广播
				this.$pubsub.unsubscribe(this.pubsubTransData);

				// flag 监听广播
				this.flags.falg_subscribes = false;
			}, // endSubscribes
			// ======================================================= 订阅消息 end ======================================================= //

			/**
			 * @Des 查询 设备GNSS
			 * @Auth
			 * @Date 
			 */
			searchTags_GNSS() {
				// 关闭 消息订阅
				this.endSubscribes();

				// 移除 点聚合marker
				this.removeAllClusterMarkers();

				// 交互 参数
				let formData = {
					projectId: this.$store.state.currentProjectId,
					total: 0,
					startNum: 0,
					limit: 0,
				};
				// 交互
				this.$request.postJsonRequest(ApiGpsTag.searchGpsTagApi, formData).then(result => {
					let keys = [];
					let rows = [];
					Object.assign([], result.rows).forEach((row, index) => {
						// 标签报警
						let alarmObj = Object.assign([], this.map_tag_alarm.get(row.did));
						let alarms = Object.assign([], alarmObj.list);

						let i = keys.indexOf(row.did);
						if(i == -1) {
							// key list
							keys.push(row.did);
							// 数据 列表
							rows.push(Object.assign({}, row, {
								didName: (row.bindName || row.nickname),
								alarms: alarms
							}));
						} else {
							this.$set(rows, i, Object.assign({}, row, {
								didName: (row.bindName || row.nickname),
								alarms: alarms
							}));
						}
					});

					// 更新数据
					this.keys = Object.assign([], keys);
					this.rows = Object.assign([], rows);
					// 列表 list
					this.tbRows = Object.assign([], this.rows).sort((a, b) => {
						return b.alarms.length - a.alarms.length;
					});

					// 初始化 点聚合
					this.initMarkerCluster();

					// 初始化 websocket
					this.initPositionWs();

					// 开启 消息订阅
					// !this.flags.falg_subscribes && this.startSubscribes();
					// 发布消息 报警数据
					// this.$pubsub.publish('pubsubHandle', {key: 'getAlarmData', data: {}});
				}).catch(error => {
					console.error('查询GNSS异常', ApiGpsTag.searchGpsTagApi);
				});
			}, // endSubscribes

			/**
			 * @Des 查询 报警类型
			 * @Auth CC
			 * @Date 
			 */
			searchAlarmStatus() {
				if(!this.$checkEmpty(this.$store.state.alarmStatus)) {
					this.alarmStatus = typeof this.$store.state.alarmStatus == 'string' ? JSON.parse(this.$store.state.alarmStatus) : Object.assign({}, this.$store.state.alarmStatus);
				} else {
					this.$request.postJsonRequest(ApiAlarmGNSS.findAlarmStatusApi, {}).then(result => {
						// console.log(result)
						let alarmStatus = Object.assign({}, {});
						if(result.code == 0) {
							alarmStatus = Object.assign({}, result.data);
						}
						this.alarmStatus = Object.assign({}, alarmStatus);
						// 记录 报警类型
						this.$store.dispatch('commitAlarmStatus', JSON.stringify(alarmStatus)); // 记录当前项目 id
					}).catch(error => {
						console.log('查询报警状态异常', error);
					})
				}
			}, // searchAlarmStatus

			// ================================================= websocket start ================================================= //
			/**
			 * @Des 初始化 websocket
			 * @Auth
			 * @Date
			 */
			initPositionWs() {
				// websocket 参数
				const code = 1; // 40发送账户的GPS定位 41发送gps设备定位(did) 42发送所有的GPS位置 1全量数据
				const time = new Date().getTime();
				const sign = this.$secret.md5(time + "{" + code + "}");
				const argJson = {
					code: code,
					time: time,
					sign: sign,
					key: this.$store.state.loginKey,
				};
				var jsonStr = JSON.stringify(argJson);
				if(this.$checkEmpty(this.$refs.positionWs_out)) {
					// 初始化websolet
					this.wsFilter.creatWsFlag = true;
				} else if(this.wsFilter.creatWsFlag) {
					this.$refs.positionWs_out.wsSend(jsonStr);
				};
			}, // initPositionWs
			// websocket 连接打开 onopen回调
			wsOnopen(event) {
				console.log('Websocket Server Connect Success');
				// this.$refs.positionWs_out.sendPing(0.5*60*1000, 'ws_out_ping');// 发送心跳包
				this.sendWsData();
				// websocket 心跳包
				this.wsPingStart();
			},
			// websocket 数据推送   onmessage回调
			wsOnmessage(event) {
				// websocket 心跳包
				this.wsPingRest();

				const data = eval('(' + event.data + ')');
				//接收数据
				this.receiveWsData(Object.assign({}, data));
			},
			// websocket 数据推送   onmessage回调
			wsOnerror(event) {
				// 清除 计时器 ws ping
				this.clearTimer_ws_ping();
			},
			// websocket 数据推送   onmessage回调
			wsOnclose(event) {
				// 清除 计时器 ws ping
				this.clearTimer_ws_ping();
			},
			// websocket 发送
			sendWsData() {
				if(!this.wsFilter.creatWsFlag) {
					return;
				}
				const code = 1; // 40发送账户的GPS定位 41发送gps设备定位(did) 42发送所有的GPS位置 1全量数据
				const time = new Date().getTime();
				const sign = this.$secret.md5(time + "{" + code + "}");
				const argJson = {
					code: code,
					time: time,
					sign: sign,
					key: this.$store.state.loginKey,
				};
				this.$refs.positionWs_out.wsSend(argJson);
			}, // sendWsData

			// websocket 心跳包
			wsPingStart() {
				this.timer_ws_ping = setTimeout(() => {
					// websocket 发送 心跳包
					this.sendWsPingData();
				}, 30 * 1000);
			}, // wsPingStart
			// websocket 心跳包 重置
			wsPingRest() {
				// 清除 计时器 ws ping
				this.clearTimer_ws_ping();

				// websocket 心跳包
				this.wsPingStart();
			}, // wsPingRest
			// 清除 计时器 ws ping
			clearTimer_ws_ping() {
				if(!this.$checkEmpty(this.timer_ws_ping)) {
					clearTimeout(this.timer_ws_ping);
					this.timer_ws_ping = null;
				}
			}, // clearTimer_ws_ping
			// websocket 发送 心跳包
			sendWsPingData() {
				// 清除 计时器 ws ping
				this.clearTimer_ws_ping();

				if(!this.wsFilter.creatWsFlag) {
					return;
				}
				const code = 0; // 40发送账户的GPS定位 41发送gps设备定位(did) 42发送所有的GPS位置 1全量数据
				const time = new Date().getTime();
				const sign = this.$secret.md5(time + "{" + code + "}");
				const argJson = {
					code: code,
					// data: 'ping',
					// type: 'ping',
					// server_time: time,
					// sign: sign,
					// key: this.$store.state.loginKey,
				};
				this.$refs.positionWs_out.wsSend(argJson);

				// websocket 心跳包
				this.wsPingStart();
			}, // sendWsPingData
			// ================================================= websocket end ================================================= //

			/**
			 * @Des 接收数据 row
			 * @Auth
			 * @Date
			 */
			reciveRow(row) {
				let alarms = [];
				let alarmMap = Object.assign({}, row.alarmMap);
				for(var key in alarmMap) {
					// 空值 跳过
					if(this.$checkEmpty(alarmMap[key])) return true;

					let alarm = Object.assign({}, alarmMap[key]);
					alarm['alarmName'] = alarm.alarmName || alarm.name;

					// 报警 开关
					let alarmStateSwitch = Object.assign({}, this.alarmStateSwitchs[alarm.code]);
					alarmStateSwitch.show && alarmStateSwitch.switch && alarms.push(Object.assign({}, alarm));
				}
				// 标签报警
				this.map_tag_alarm.put(row.did, Object.assign({}, {
					tagId: row.did,
					did: row.did,
					list: Object.assign([], alarms)
				}));

				let index = this.keys.indexOf(row.did);
				if(index == -1) {
					// key list
					this.keys.push(row.did);
					// 数据 列表
					this.rows.push(Object.assign({}, row, {
						didName: (row.bindName || row.nickname),
						alarms: alarms
					}));
					// 添加 点聚合marker
					this.addClusterMarker(Object.assign({}, row, {
						didName: (row.bindName || row.nickname),
						alarms: alarms
					}));

					// 绘制 图元
					// this.drawMarker(row);
				} else {
					this.$set(this.rows, index, Object.assign({}, row, {
						didName: (row.bindName || row.nickname),
						alarms: alarms
					}));
					// 更新 点聚合marker
					this.updateClusterMarker(Object.assign({}, row, {
						didName: (row.bindName || row.nickname),
						alarms: alarms
					}));

					// 移除 marker
					// this.mapFn.removeMarker(row.did);
					// 绘制 图元
					// this.drawMarker(row);
				}

				// 列表 list
				this.tbRows = Object.assign([], this.rows).sort((a, b) => {
					return b.alarms.length - a.alarms.length;
				});

			}, // reciveRow

			/**
			 * @Des 接收数据 报警
			 * @Auth
			 * @Date
			 */
			reciveAlarmRow(code, row) {
				// 空值 跳过
				if(!code || this.$checkEmpty(row)) return false;

				if(code == 2) {
					// 标签 报警 {tagId, alarm, status}
					// 空值 跳过
					if(this.$checkEmpty(row.tagId)) return false;

					// 提取记录
					let alarmObj = Objec.assign({}, this.map_tag_alarm.get(row.tagId));
					let alarmKeys = Objec.assign([], alarmObj.keys);
					let alarmList = Objec.assign([], alarmObj.list);

					// 解析数据
					let alarmName = this.alarmStatus[row.alarm];
					let index = alarmKeys.indexOf(row.alarm);
					if(status == 1) {
						if(index == -1) {
							alarmKeys.push(row.alarm);
							alarmList.push({
								code: row.alarm,
								alarmName: alarmName,
								time: row.time,
								status: row.status,
							})
						} else {
							alarmList[index] = {
								code: row.alarm,
								alarmName: alarmName,
								time: row.time,
								status: row.status,
							};
						}
					} else {
						alarmKeys.splice(index);
						alarmList.splice(index);
					}

					// 标签报警
					this.map_tag_alarm.put(row.tagId, Object.assign({}, {
						tagId: row.tagId,
						did: row.tagId,
						list: Object.assign([], alarmList),
						keys: Object.assign([], alarmKeys),
					}));

					// 列表 list
					this.tbRows = Object.assign([], this.rows).sort((a, b) => {
						return b.alarms.length - a.alarms.length;
					});
					let rowIndex = this.keys.indexOf(row.tagId);
					let posiRow = Object.assign({}, this.rows[rowIndex]);
					// 更新 点聚合marker
					this.updateClusterMarker(Object.assign({}, posiRow, {
						didName: (posiRow.bindName || posiRow.nickname),
						alarms: alarmList
					}));
				} else if(code == 3) {
					// 标签 离线
					let index = this.keys.indexOf(row.tagId);
					if(index >= 0) {
						// key list
						this.keys.splice(index);
						// 数据 列表
						this.rows.splice(index);
						// 移除 点聚合marker
						this.removeClusterMarker(row.tagId);

						// 列表 list
						this.tbRows = Object.assign([], this.rows).sort((a, b) => {
							return b.alarms.length - a.alarms.length;
						});
					}
				}

			}, // reciveAlarmRow

			//接收 ws 数据
			receiveWsData(dataObj) {

				if(dataObj.code == 1) {
					// websocket连接成功

					// 接收数据 row
					this.reciveRow(Object.assign({}, dataObj.data));

					/*
					const code = 40;// 40发送账户的GPS定位 41发送gps设备定位(did) 42发送所有的GPS位置
					const time = new Date().getTime();
					const sign = this.$secret.md5(time + "{" + code + "}");
					const argJson = {
						code: code,
						time: time,
						sign: sign,
						key: this.$store.state.loginKey,
					};
					this.$refs.positionWs_out.wsSend(jsonStr);
					*/

					// 发布消息 地图连接
					// this.$pubsub.publish('sendPositionWs', argJson);
				}

				if(dataObj.code == 2) {
					// 报警 {tagId, alarm, status}

					// 接收数据 报警
					this.reciveAlarmRow(2, Object.assign({}, dataObj.data));
				}

				if(dataObj.code == 3) {
					// 离线标签

					// 接收数据 报警
					this.reciveAlarmRow(3, Object.assign({}, dataObj.data));
				}

				if(dataObj.code == 120) {
					//位置数据

					// 接收数据 row
					this.reciveRow(Object.assign({}, dataObj.data));
				}

				if(dataObj.code == 101) {
					//标签 发生变化

					// 清除计时器
					if(!this.$checkEmpty(this.timer_101)) {
						return false;
					}
					// 延后执行
					this.timer_101 = setTimeout(() => {
						// 清除计时器
						if(!this.$checkEmpty(this.timer_101)) {
							clearTimeout(this.timer_101);
							this.timer_101 = null;
						}

						// 查询 设备GNSS
						this.searchTags_GNSS();
					}, 500);
				}

				if(dataObj.code == 110) {
					// 变化 系统时间

					this.systemTime = dataObj.data;
				}

			}, // receiveWsData

			// ======================================================= 刷新数据 start ======================================================= //
			/**
			 * @Des 刷新 报警数据
			 * @Auth
			 * @Date 
			 */
			flushAlarmsData(data) {
				// 报警 类型
				this.alarmStates = Object.assign({}, data.alarmStates);
				// 报警 开关
				this.alarmStateSwitchs = Object.assign({}, data.alarmStateSwitchs);

				// 标签报警
				this.map_tag_alarm.clear();
				// 标签 报警
				Object.assign([], data.tagAlarmsInfo).forEach((row, index) => {
					// 空值 跳过
					if(this.$checkEmpty(row)) return true;
					// 标签报警
					this.map_tag_alarm.put(row.tagId, Object.assign({}, row, {
						did: row.tagId
					}));
				});
			}, // flushAlarmsData
			/**
			 * @Des 刷新 位置数据
			 * @Auth
			 * @Date 
			 */
			flushPositionData() {
				this.rows.forEach((row, index) => {
					// 标签报警
					let alarmObj = Object.assign([], this.map_tag_alarm.get(row.did));
					let alarms = Object.assign([], alarmObj.list);
					row.alarms = Object.assign([], alarms);
				});
				// 列表 list
				this.tbRows = Object.assign([], this.rows).sort((a, b) => {
					return b.alarms.length - a.alarms.length;
				});
			}, // flushPositionData
			// ======================================================= 刷新数据 end ======================================================= //

			// ======================================================= 快捷列表 start ======================================================= //
			/**
			 * @Des 事件 区域列表
			 * @Auth
			 * @Date 
			 */
			clickAreaRow(row) {
				// 空值 跳过
				if(this.$checkEmpty(row) || this.$checkEmpty(row.node)) return false;
				let item = Object.assign({}, row.node);

				// this.mapFn.setZoom(8);
				// this.mapFn.setCenter([item.startPointX, item.startPointY]);
				this.mapFn.setZoomAndCenter(8, [item.startPointX, item.startPointY]);
				this.mapFn.setZoom(10);
			}, // clickAreaRow
			// ======================================================= 快捷列表 end ======================================================= //

		}, // methods

		/**
		 * @Des 监听
		 * @Auth
		 * @Date 
		 */
		watch: {

		}, // watch

		/**
		 * @Des 实时计算
		 * @Auth
		 * @Date 
		 */
		computed: {

		}, // computed

	} // export default
</script>

/* CSS */
<style lang="scss" scoped>
	/* 表单 地图 */
	
	/deep/ .form-out-map {
		position: absolute;
		top: 10px;
		right: 10px;
		.el-form-item {
			margin: 0;
		}
		.el-input .el-input__clear {
			line-height: 30px;
			background-color: #061b3d;
		}
		/* 输入框 */
		.el-input__inner {
			height: 30px;
			font-size: 14px;
			padding-left: 5px;
			padding-right: 5px;
		}
		/* el-input__inner */
		.el-input-group__append,
		.el-input-group__prepend {
			padding: 0 10px;
			button.el-button {
				padding: 0 10px;
				margin: -10px -10px;
			}
			/* button.el-button */
		}
		/* group__append group__prepend */
	}
	/* form-out-map */
	
	.el-button--success {
		background-color: #67C23A;
		border-color: #67C23A;
	}
	
	.el-button--primary {
		background-color: #409EFF;
		border-color: #409EFF;
	}
	
	.el-button--info {
		background-color: #909399;
		border-color: #909399;
	}
	
	.el-button--danger {
		background-color: #F56C6C;
		border-color: #F56C6C;
	}
	
	.aside-button-box {
		width: 60px;
		height: 40px;
		position: absolute;
		top: 0;
		bottom: 0;
		margin: auto;
		&.r-0 {
			left: 0;
			right: auto;
		}
		&.r-30 {
			left: 420px;
			right: auto;
		}
		.el-button {
			border-image: none;
			box-shadow: none;
		}
	}
	/* aside-button-box */
	
	/deep/ .beautifyTableClass {
		height: 100%;
		.el-table {
			height: 100%;
		}
		.el-table__body-wrapper {
			overflow-y: auto;
		}
		.el-table th>.cell {
			height: 40px;
			line-height: 40px;
		}
		.el-input__inner {
			height: 35px;
			border-color: #ccc;
			background-color: #fff;
			color: #000;
		}
		.el-table__empty-block {
			background-color: #eee;
			color: #ccc;
		}
		.el-button {
			border-image: none;
			box-shadow: none;
		}
	}
	/* beautifyTableClass */
	
	.area-items-box,
	.map-items-box {
		ul {
			background-color: #034178;
			/*border-image: linear-gradient(90deg, #0A9AFB, #0A9AFB, #0A9AFB) 1 1;*/
			li {
				width: auto;
				min-width: max-content;
				max-width: 200px;
				background-color: #061b3d;
				color: #e9eaeb;
				&:hover {
					border-color: #4681bf;
				}
			}
		}
		/* ul */
	}
	/* area-items-box map-items-box */
</style>
<!--<style lang="scss" src="@/static_dazzle/css/amap/amap.scss"></style>-->

/* CSS */
<style lang="scss">
	/* 右键菜单 旗帜 */
	
	.context-menu-flag {
		.menu_item {
			padding-right: 20px !important;
		}
		&.none-children {
			.menu_item_expand_icon {
				display: none;
			}
		}
	}
	/* context-menu-flag */
</style>


// WEBPACK FOOTER //
// src/components_outdoor/Home/DeviceDistribution.vue